import React from 'react';

/** Keeps the identity header on the canvas and the form at one border level. */
export function SettingsLayout({
  header,
  navigation,
  children,
  actions,
}: {
  header: React.ReactNode;
  navigation?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div className="min-w-0 space-y-6">
      {header}
      <div className="grid min-w-0 grid-cols-1 gap-6 lg:grid-cols-[15rem_minmax(11rem,1fr)]">
        {navigation && (
          <nav
            aria-label="Settings categories"
            className="min-w-0 lg:border-r lg:border-border lg:pr-4"
          >
            {navigation}
          </nav>
        )}
        <div className={navigation ? 'min-w-0' : 'min-w-0 lg:col-span-2'}>{children}</div>
      </div>
      {actions}
    </div>
  );
}
export function ContextRail({
  children,
  label = 'Record context',
}: {
  children: React.ReactNode;
  label?: string;
}) {
  return (
    <aside
      aria-label={label}
      className="min-w-0 space-y-4 border-t border-border pt-4 font-body text-body lg:border-l lg:border-t-0 lg:pl-4 lg:pt-0"
    >
      {children}
    </aside>
  );
}
